define('extensions/i18n/knockout.lString',['lib/knockout'], function (ko) {
    'use strict';

    /**
     * <p>Binding handler for rendering localized strings. Parameters are:</p>
     * <dl>
     *  <dt>name</dt>
     *  <dd>the identifier of the string to render in the current locale</dd>
     *  <dt>data</dt>
     *  <dd>the data to perform token replacement against.</dd>
     *</dl>
     * <pre class="prettyprint">
     * &lt;span data-bind="lString: {name: 'string.id', data: dataObj}"&gt;
     *   &lt;!-- localized string.id appears here, token replacement is done against dataObj --&gt;
     * &lt;/span&gt;
     * </pre>
     * <p>
     *   As a shorthand syntax, the string identifier can be passed directly. Token replacement
     *   will be performed against the current view model.
     * </p>
     * <pre class="prettyprint">
     * &lt;span data-bind="lString: 'string.id'"&gt;
     *   &lt;!-- localized string.id appears here, token replacement is done against the currently bound view model --&gt;
     * &lt;/span&gt;
     * </pre>
     *
     * @exports extensions/i18n/knockout-lString
     */
    ko.bindingHandlers.lString = {
        init: function () {},
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var stringKey, data, locale,
                templateInfo = ko.unwrap(valueAccessor());

            if (!templateInfo || typeof templateInfo === 'string') {
                stringKey = templateInfo;
                data = viewModel;
            } else if (templateInfo) {
                stringKey = templateInfo.name;
                data = templateInfo.data || viewModel;
                locale = templateInfo.locale;
            }
            if(!stringKey) {
                element.innerHTML = "";
                return;
            }

            element.innerHTML = ko.i18n.renderString(stringKey,
                                                     data,
                                                     locale);
        }
    };

    return ko.bindingHandlers.lString;
});

